import { TOGGLE, SEARCH_SONGS, SEARCH_ALBUMS, SEARCH_ARTISTS } from './actions';

const initialState = {
  /**
   * Whether to show the search modal or not
   */
  searching: false,

  /**
   * Songs that matched the query search
   */
  songs: {
    total: 0,
    results: [],
  },
  
  /**
   * Albums that matched the search query
   */
  albums: {
    total: 0,
    results: [],
  },
  
  /**
   * Artists that matched the search query
   */
  artists: {
    total: 0,
    results: [],
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE:
      return {
        ...state,
        searching: !state.searching,
      };
    case SEARCH_SONGS.SUCCESS:
      return {
        ...state,
        songs: {
          total: action.payload.meta.total,
          results: action.payload.songs,
        },
      };
    case SEARCH_ALBUMS.SUCCESS:
      return {
        ...state,
        albums: {
          total: action.payload.meta.total,
          results: action.payload.albums,
        },
      };
    case SEARCH_ARTISTS.SUCCESS:
      return {
        ...state,
        artists: {
          total: action.payload.meta.total,
          results: action.payload.artists,
        },
      };
    default:
      return state;
  }
}
